import React from 'react'
import PropTypes from 'prop-types'
import { Formik, Form, Field } from 'formik'
import { ProfileApi } from 'SRC/modules/users/Profile/api'
import { AdApi } from 'SRC/modules/ads/shared/api'
import { connect } from 'react-redux'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import { Notification } from 'react-notification'
import { getCountries } from 'SRC/modules/geoObjects/countries/selectors'
import { Preloader } from 'SRC/ui/Preloader'
import { PhoneInputWithSelectDial } from 'SRC/ui/FormElementsNew'
import config from 'SRC/config/config.yaml'
import { Image } from '../Image'

class UpdateAgentForm extends React.Component {
  constructor (props) {
    super(props)

    const { agent } = props

    this.cookies = new CookiesHelper()
    this.api = new ProfileApi()
    this.adApi = new AdApi()

    this.state = {
      formNotification: '',
      image: (agent && agent.image) || null
    }
  }

  onSubmit = async (values, actions) => {
    const { goToList } = this.props
    const { image } = this.state

    const formData = new FormData()

    const userId = this.cookies.get('userId')
    const token = this.cookies.get('token')

    formData.append('userId', userId)
    formData.append('token', token)

    formData.append('agent', values.agent)
    formData.append('name', values.name)

    if (values.email) {
      formData.append('email', values.email)
    }

    const phone = `${values.dial}${values.phone.replace(/ /g, '')}`
    console.log('PHONE VAL', phone)

    formData.append('phone', phone)

    // const imageUrl = await this.getUploadedImageUrl()

    // if (imageUrl) {
    //   console.log('image', imageUrl)
    //   formData.append('image', `${config.mediaCDN}${imageUrl}`)
    // }
    if (image && image.file) {
      formData.append('image', image.file)
    }

    const result = await this.api.updateAgent(formData)

    if (result && result.agent) {
      this.setState({ formNotification: 'Agent je uspješno ažuriran.' })

      setTimeout(() => {
        if (goToList) goToList()
      }, 2000)
    } else {
      this.setState({ formNotification: 'Greška. Agent nije ažuriran.' })
    }
  }

  getUploadedImageUrl = async () => {
    const { image } = this.state

    if (image && image.file) {
      const formData = new FormData()

      formData.append('images', image.file)

      const result = await this.adApi.uplodAdImages(formData)

      if (result && result.status === 'ok' && Array.isArray(result.images) && result.images.length) {
        return result.images[0]
      }
    }

    return null
  }

  prepareCountries = () => {
    const { countries } = this.props

    if (!Array.isArray(countries)) return []

    return countries.filter(country => !country.parent).map(country => {
      const isGrouped = !!countries.find(item => item.parent === country.id)

      return {
        id: country.id,
        label: country.label,
        value: country.id,
        dial: country.dial,
        isGrouped,
        options: isGrouped ? countries.filter(item => item.parent === country.id).map(childCountry => ({
          id: childCountry.id,
          value: childCountry.id,
          label: childCountry.label,
          dial: childCountry.dial
        })) : null
      }
    })
  }

  setImage = image => {
    console.log('setImage', image)

    this.setState({ image })
  }

  render () {
    const { initialValues } = this.props
    const { formNotification, image } = this.state

    return <Formik
      onSubmit={this.onSubmit}
      initialValues={initialValues}
      enableReinitialize
      validate={values => {
        const errors = {}

        if (!values.name) {
          errors.name = 'Obavezno polje'
        }

        if (values.name.length < 3) {
          errors.name = 'Minimalna dužina je 3 karaktera'
        }

        if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
          errors.email = 'Nevalidna email adresa'
        }

        if (!values.phone || values.phone.length < 8) {
          errors.phone = 'Nevalidan broj telefona'
        }

        return errors
      }}
    >
      {formikProps => {
        return (
          <Form className='agent-form'>
            <div className='form-group'>
              <label>Ime i prezime</label>
              <Field
                name='name'
                id='name'
                label='Ime i Prezime'
                isRequired
              />
              {formikProps.dirty && formikProps.errors.name ? <p className='form-group__error'>{formikProps.errors.name}</p> : null}
            </div>

            <div className='form-group'>
              <label>Email</label>
              <Field
                name='email'
                id='email'
                label='Email'
                isRequired
              />
              {formikProps.dirty && formikProps.errors.email ? <p className='form-group__error'>{formikProps.errors.email}</p> : null}
            </div>

            <div className='login-form'>
              <PhoneInputWithSelectDial
                label={config.loginForm.labels.phone}
                isFullWidth={false}
                inputClass='form-group__login-phone'
                field={{ name: 'phone' }}
                form={formikProps}
                countries={this.prepareCountries()}
                onMouseEnter={this.setPhoneActiveTip}
              />
            </div>

            <Image image={image} setImage={this.setImage} />

            <button
              key='submit'
              className='btn-oglas-submit ads-add__submit'
              type='submit'
            >
              Izmijeni agenta
            </button>
            <Notification isActive={formNotification} message={formNotification || ``}
              action={'Sakrij'} onClick={() => { this.setState({ formNotification: '' }) }}
            />
            {formikProps.isSubmitting ? <Preloader /> : null}
          </Form>
        )
      }}
    </Formik>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { agent } = ownProps

  const dial = agent && agent.phone ? agent.phone.substring(0, 3) : 382
  const phone = agent && agent.phone ? agent.phone.substring(3, agent.phone.length) : ''

  const initialValues = {
    agent: agent ? agent.id : null,
    name: agent ? agent.name : '',
    email: agent ? agent.email : '',
    phone,
    dial,
    image: agent ? agent.image : ''
  }

  return {
    initialValues,
    countries: getCountries(state)
  }
}

UpdateAgentForm.propTypes = {
  agent: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    email: PropTypes.string,
    image: PropTypes.string,
    phone: PropTypes.string
  }).isRequired,
  countries: PropTypes.array.isRequired,
  initialValues: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    image: PropTypes.string
  }).isRequired,
  goToList: PropTypes.func.isRequired
}

export default connect(mapStateToProps)(UpdateAgentForm)
